import React from 'react'
import { useParams } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import NavBar from '../components/NavBar';
import Bank from '../components/banks/Bank';
import ViewBanks from '../components/banks/ViewBanks';

const BanksView = () => {

    const bankId = useParams();

    return (
        <div>
            <Header />
            <NavBar />
            <Bank bankIdToEdit={bankId} />
            <ViewBanks limit={6}/>
            <Footer />
        </div>
    )
}

export default BanksView
